import { handleActions } from 'redux-actions';

export const defaultRoomData = {
	id: -1,
	apartmentId: -1,
	name: '',
	number: '',
	type: '',
	status: 'AVAILABLE',
	price: 0,
	energyPrice: 0,
	deposit: 0,
	pingNumber: 0,
	releaseTime: '2018-06-19 16:43:20',
	sexLimit: 'MALE',
	maxOrder: 0,
	double: 0,
	pet: 0,
	createdAt: '2018-06-19 16:43:20',
	updatedAt: '2018-06-19 16:43:20',
	photos: [],
	tags: [],
	hasProcessingEvent: [],
	hasProcessingOrder: [],
	users: [],
	roommate: [],
};

export default handleActions(
	{
		FETCH_ROOM_PENDING: state => ({
			...state,
			list: [],
		}),

		FETCH_ROOM_FULFILLED: (state, action) => ({
			...state,
			...action.payload,
		}),

		FETCH_ROOM_BY_ID_FULFILLED: (state, action) => ({
			...state,
			data: {
				...state.data,
				...action.payload.data,
			},

			recommend: action.payload.recommend,
		}),

		UPDATE_ROOM: (state, action) => ({
			...state,
			data: {
				...state.data,
				...action.payload,
			},
		}),

		FETCH_MORE_ROOM_FULFILLED: (state, action) => ({
			...state,

			list: [...state.list, ...action.payload.list],
			data: { ...state.data, ...action.payload.data },
			currentPage: action.payload.currentPage,
			lastPage: action.payload.lastPage,
			perPage: action.payload.perPage,
			total: action.payload.total,
		}),

		FETCH_COLLECT_FULFILLED: (state, action) => ({
			...state,

			data: {
				...state.data,
				...action.payload.roomData,
			},
		}),
	},
	{
		list: [],
		data: {},
		recommend: [],
		currentPage: 0,
		lastPage: 0,
		perPage: 0,
		total: 0,
	},
);



// WEBPACK FOOTER //
// ./src/reducers/room.js